import { theme } from 'antd';
import { splitLines } from 'utils/String';

// Tokens at module scope: see components/UI/Table/Column.tsx for the rationale.
const { fontSize, lineHeight, lineWidth, paddingXS } = theme.getDesignToken();

// Height of one line of body text. 14 * 1.5714... = 22px at current tokens.
const LINE_PX = fontSize * lineHeight;

// The comment textareas pad `paddingXS` top and bottom and carry a 1px border.
// box-sizing is border-box (from antd's reset), so both count toward `height`.
const CHROME_PX = 2 * paddingXS + 2 * lineWidth;

interface TextareaHeightOptions {
    /**
     * Stop growing past this many lines, leaving the textarea to scroll.
     * Uncapped by default.
     */
    maxLines?: number;
}

/**
 * The `height` a textarea needs in order to show `text` without scrolling,
 * as a px string.
 *
 * Derived from antd's font and spacing tokens rather than hardcoded, so it
 * follows the theme instead of drifting from it. Note this assumes the caller
 * is styled like the comment textareas -- body font size, `paddingXS` vertical
 * padding, 1px border.
 */
export function textareaHeight(
    text: string,
    { maxLines = Infinity }: TextareaHeightOptions = {}
) {
    const lineCount = Math.min(splitLines(text).length, maxLines);
    return `${Math.round(lineCount * LINE_PX + CHROME_PX)}px`;
}
